import React from "react";


const TextLine = ({children}) => {
    return (
        <p className={'text-sm'}>
            {children}
        </p>
    )
}

export default TextLine
